import {FormikProps} from 'formik';
import {ChangeEvent} from 'react';
import LikeInputOutlet from '../../../../components/IlikeIputOutlet';
import Num2persian from '../../../../utilities/helper/convertNumToPersian';
import {IProductForm} from './productFormData';

interface IProps {
  form: FormikProps<IProductForm>;
}

const PriceInput = ({form}: IProps) => {
  return (
    <section>
      <p className="mb-2 color-gray-1 text-md">قیمت محصول</p>

      <LikeInputOutlet
        name="price"
        label=""
        value={form?.values?.price || ''}
        placeholder="قیمت محصول را وارد کنید"
        type="number"
        touched={!!form?.values.price}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          form.setFieldValue('price', e.target.value);
        }}
      />

      {form.values.price && (
        <span className="text-xs text-farm-shop-500">
          {Num2persian(form.values.price?.toString())} تومان
        </span>
      )}
    </section>
  );
};

export default PriceInput;
